import api from '../../utils/api';
import {
    GET_TREATMENT_NOTES,
    GET_PENDING_TREATMENT_NOTES,
    GET_TREATMENT_NOTE_DETAIL,
    CREATE_TREATMENT_NOTE,
    UPDATE_TREATMENT_NOTE,
    CONFIRM_TREATMENT_NOTE,
    UNCONFIRM_TREATMENT_NOTE,
    CONFIRM_EDIT_TREATMENT_NOTE,
    REMOVE_TREATMENT_NOTES,
    GET_TREATMENT_NOTES_STATISTIC_BY_DOCTOR
} from './types';
import { NotificationManager } from 'react-notifications';

// Lấy danh sách treatment notes
export const getTreatmentNotes = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/treatment-notes', { params: filter }).then(res => {
            //console.log('res a', res);
            dispatch({ type: GET_TREATMENT_NOTES, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Đã có lỗi xảy ra');
            reject(err);
        });
    });
};

// Lấy chi tiết một treatment note
export const getTreatmentNoteDetail = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/treatment-notes/${id}`).then(res => {
            dispatch({ type: GET_TREATMENT_NOTE_DETAIL, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không tìm thấy ghi chú');
            reject(err);
        });
    });
};

// Tạo mới
export const createTreatmentNote = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/treatment-notes', data).then(res => {
            dispatch({ type: CREATE_TREATMENT_NOTE, payload: res.data.data });
            NotificationManager.success('Thêm mới ghi chú thành công!');
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Thêm mới thất bại');
            reject(err);
        });
    });
};

// Cập nhật ghi chú
export const updateTreatmentNote = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/treatment-notes/${id}`, data).then(res => {
            dispatch({ type: UPDATE_TREATMENT_NOTE, payload: res.data.data });
            NotificationManager.success('Cập nhật ghi chú thành công!');
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Cập nhật thất bại');
            reject(err);
        });
    });
};

// Xác nhận ghi chú
// export const confirmTreatmentNote = (ids) => dispatch => {
//     return new Promise((resolve, reject) => {
//         return api.put(`/treatment-notes/treatment-notes/${ids}/confirm`).then(res => {
//             dispatch({ type: CONFIRM_TREATMENT_NOTE, payload: res.data.data });
//             NotificationManager.success('Xác nhận thành công!');
//             resolve(res.data.data);
//         }).catch(err => {
//             NotificationManager.error(err.response?.data?.msg || 'Xác nhận thất bại');
//             reject(err);
//         });
//     });
// };
export const confirmTreatmentNote = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put('/treatment-notes/treatment-notes/confirm', { ids }) // <-- gửi qua body
            .then(res => {
                dispatch({ type: CONFIRM_TREATMENT_NOTE, payload: res.data.data });
                NotificationManager.success('Xác nhận thành công!');
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(err.response?.data?.msg || 'Xác nhận thất bại');
                reject(err);
            });
    });
};


// Xác nhận và chỉnh sửa
export const confirmEditTreatmentNote = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/treatment-notes/treatment-notes/${id}/confirm-edit`, data).then(res => {
            dispatch({ type: CONFIRM_EDIT_TREATMENT_NOTE, payload: res.data.data });
            NotificationManager.success('Xác nhận và chỉnh sửa thành công!');
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Thao tác thất bại');
            reject(err);
        });
    });
};

// Hủy xác nhận
export const unconfirmTreatmentNote = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/treatment-notes/treatment-notes/${id}/unconfirm`).then(res => {
            dispatch({ type: UNCONFIRM_TREATMENT_NOTE, payload: res.data.data });
            NotificationManager.success('Đã hủy xác nhận!');
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Hủy xác nhận thất bại');
            reject(err);
        });
    });
};

// Xóa nhiều ghi chú
export const removeTreatmentNotes = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete('/treatment-notes', { data: { ids } }).then(res => {
            dispatch({ type: REMOVE_TREATMENT_NOTES, payload: ids });
            NotificationManager.success('Đã xoá ghi chú!');
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Xóa thất bại');
            reject(err);
        });
    });
};
